import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "¿Cómo solicito mi presupuesto?",
    a: "Haga clic en «Crear mi presupuesto» y complete el breve formulario con sus datos y el tipo de equipo que necesita. Al enviarlo, su solicitud llegará directamente a nuestro WhatsApp oficial y recibirá una respuesta personalizada con la mayor brevedad posible.",
  },
  {
    q: "¿Qué cubre exactamente la garantía de instalación de 2 años?",
    a: "Cubre cualquier posible incidencia derivada de nuestra intervención: líneas frigoríficas, soportes, conexiones eléctricas, desagües y pruebas de estanqueidad. Durante 24 meses, cualquier corrección relacionada con la instalación es completamente gratuita.",
  },
  {
    q: "¿Cuánto tarda la instalación de un equipo 1x1?",
    a: "Una instalación split 1x1 estándar se completa habitualmente en una sola jornada, dejando el espacio limpio, probado y en pleno funcionamiento antes de que nuestro equipo abandone su domicilio o negocio.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="bg-white py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-12">
        <Reveal className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-ocean-600">
            Preguntas Frecuentes
          </p>
          <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl text-balance">
            Resolvemos sus dudas antes de instalar
          </h2>
        </Reveal>

        <div className="mt-12 space-y-4">
          {FAQS.map((item, i) => (
            <Reveal key={item.q} delay={i * 0.08}>
              <div
                className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-50/50 transition-colors duration-300 hover:border-ocean-600/30"
                data-testid={`faq-item-${i}`}
              >
                <button
                  data-testid={`faq-question-${i}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-display text-base font-bold text-navy sm:text-lg">
                    {item.q}
                  </span>
                  <motion.span
                    animate={{ rotate: open === i ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="shrink-0 text-ocean-600"
                  >
                    <ChevronDown className="h-5 w-5" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 pb-6 text-sm leading-relaxed text-slate-600" data-testid={`faq-answer-${i}`}>
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
